import React, { Component, PropTypes } from 'react';
import { Modal, Form, Input, Row, Col, Select, Button, Icon, InputNumber, Radio } from 'antd';
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const Option = Select.Option;

const unitType = {
  '1': '%',
  '2': '￥',
  '3': ' '
}

class AddKRFormInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unit: '',
      defaultUnit: '1'
    }
  }

  componentWillMount() {
    this.setState({
      unit: this.props.kr && this.props.kr.kid ? this.props.kr.unit.toString() : this.state.defaultUnit
    });
  }

  componentWillReceiveProps(props) {
    if (this.props.visible !== props.visible && props.visible) {
      const unit = props.kr && props.kr.kid ? props.kr.unit.toString() : this.state.defaultUnit
      this.setState({
        unit: unit
      });
    }
  }

  changeUnit = (e) => {
    console.log('changeUnit', e);
    this.setState({
      unit: e.target.value
    });
    this.props.form.setFieldsValue({
      unit: e.target.value
    });
  }

  render() {
    const { form, objective, objectives, kr } = this.props;
    const { getFieldDecorator } = form;
    const config = {
      newName: { rules: [{ required: true, message: '请输入名称' }], initialValue: kr.title || '' },
      newDescription: { rules: [{ message: '请输入描述' }], initialValue: kr.description || '' },
      newMetric: {
        initialValue: kr.metric || ''
      },
      startValue: { initialValue: kr.startValue || 0 },
      endValue: { initialValue: kr.endValue || 0 },
      unit: { initialValue: kr.kid ? kr.unit.toString() : this.state.defaultUnit },
      weightE2: { rules: [{ required: true, message: '权重值必须在1-100之间', min: 1, max: 100, type: 'number' }], initialValue: kr.weightE2 ? kr.weightE2 : 1 },
      oid: { initialValue: objective.oid ? objective.oid.toString() : '' }
    }
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    }

    return (
      <Form layout="inline" className="add-kr-view">
        <Row style={{ width: '100%' }}>
          <Col span={24}>
            <FormItem label="名称:" {...formItemLayout} className="signle-line">
              {getFieldDecorator('title', config.newName)(
                <Input />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <FormItem label="描述:" {...formItemLayout} className="signle-line">
              {getFieldDecorator('description', config.newDescription)(
                <Input type="textarea" autosize={{ minRows: 3, maxRows: 4 }} />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <FormItem label="指标类型" {...formItemLayout} className="signle-line">
              {getFieldDecorator('metric', config.newMetric)(
                <Input />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <FormItem label="权重" {...formItemLayout} className="signle-line">
              {getFieldDecorator('weightE2', config.weightE2)(
                <InputNumber style={{ width: '100%' }} min={1} max={100} />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span={22}>
            <FormItem label="起始值" {...formItemLayout} className="signle-line">
              {getFieldDecorator('startValue', config.startValue)(
                <Input type="number" className="number-with-unit" />
              )}
            </FormItem>
          </Col>
          <Col span={2} className="unit-info">
            <span>{unitType[this.state.unit]}</span>
          </Col>
        </Row>

        <Row>
          <Col span={22}>
            <FormItem label="目标值" {...formItemLayout} className="signle-line">
              {getFieldDecorator('endValue', config.endValue)(
                <Input type="number" className="number-with-unit" />
              )}
            </FormItem>
          </Col>
          <Col span={2} className="unit-info">
            <span>{unitType[this.state.unit]}</span>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <FormItem label="单位：" {...formItemLayout} className="signle-line">
              <RadioGroup size="large" onChange={this.changeUnit} value={this.state.unit}>
                <RadioButton value="1" name="%">%</RadioButton>
                <RadioButton value="2" name="￥">￥</RadioButton>
                <RadioButton value="3" name=''>空</RadioButton>
              </RadioGroup>
              {getFieldDecorator('unit', config.unit)(
                <Input type='hidden' />
              )}
            </FormItem>

          </Col>
        </Row>
        {
          !kr.kid && objective.oid ? (
            <Row>
              <Col span={24}>
                <FormItem label="目标" {...formItemLayout} className="signle-line">
                  {getFieldDecorator('oid', config.oid)(
                    <Select className="unit-more-select">
                      <Option value={objective.oid.toString()} key={objective.oid.toString()}>{objective.title}</Option>
                    </Select>
                  )}
                </FormItem>
              </Col>
            </Row>
          ) : null
        }

      </Form>
    )
  }
}

const AddKRForm = Form.create({
})(AddKRFormInfo);

export default AddKRForm;


// WEBPACK FOOTER //
// ./src/components/okr_manage/add_kr_form.js